import JQuery from 'jquery';

var base64 = require('base64_js');
let $ = JQuery;
//var url = "http://89.252.181.6/kaderfood/kaderfood-api/view/";
var url = "https://www.kaderfood.ch/kaderfood-api/view/";
//var url = "http://192.168.1.198/kaderfood-api-27-nisan-2023/view/" //hümeyra

var WSProvider = {
    resim: url + "../../resimler",
    ajaxPost: function(serviceName, jsonParams) {
        var service = new Promise(function(resolve, reject) {
            return $.ajax({
                type: 'POST',
                url: url + serviceName + ".php",
                datatype: 'application/json',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                data: jsonParams,
                success: function(result) {
                    if (result) {
                        resolve(JSON.parse(result))
                    } else {
                        resolve()
                    }
                },
                error: function(request) {
                    console.log(request)
                }
            })
        })
        return service
    },
    ajaxPostMobil: function(data) {
        var service = new Promise(function(resolve) {
            return $.ajax({
                "url": "https://fcm.googleapis.com/fcm/send",
                "method": "POST",
                "timeout": 0,
                "headers": {
                    "Authorization": "key=AAAAAKtdPDs:APA91bE2IrRcwz5UKo5WqJcVeBmsph2U6fyW5IDxdLM6iDh1L8HwVJn4rPnx1ohtaWXs4sGv2bkt7CBovTHxKb7ZdiTv-6qeTRqjag1lnFlXs2zFk6jTQrjuBsIqTrVg3c7-qx-sFpeA",
                    "Content-Type": "application/json"
                },
                "data": JSON.stringify(data),
                success: function(result) {
                    if (result) {
                        resolve(JSON.parse(result))
                    } else {
                        resolve()
                    }
                },
                error: function(request) {
                    console.log(request)
                }
            })
        })
        return service
    },
    ajaxGet: function(serviceName, methodName, jsonParams) {
        var service = new Promise(function(resolve, reject) {
            return $.ajax({
                type: 'GET',
                url: url + serviceName + ".php",
                data: {
                    "data": base64.encode(encodeURI(JSON.stringify(jsonParams)))
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                enctype: "application/json",
                datatype: 'json',
                success: function(result) {
                    resolve(result)
                },
                error: function(request) {
                    resolve(false)
                }
            })
        })
        return service
    },
}
export default WSProvider